import axios from "axios";
import { handleGeneralError, handleNetworkError } from "./tools";
import { bossEnv } from "../config";

const request = axios.create({
    baseURL: '',
    timeout: 30000,
});

//请求拦截器
request.interceptors.request.use(
    (config) => {
        if (config.headers) {
            config.headers.token = localStorage.getItem("token") || "";
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
//响应拦截器
request.interceptors.response.use(
    (response) => {
        if (response.status !== 200) return Promise.reject(response.data);
        handleGeneralError(response);
        return response.data;
    },
    (error) => {
        handleNetworkError(error.response.status);
        return Promise.reject(error);
    }
);
export default request;